import withEditarRegistroDocente from "../../hoc/Docentes/withEditarRegistroDocente";
import RegistroDocente from "../../view/components/RegistroUsuarios/RegistroUsuarios";

export default withEditarRegistroDocente(RegistroDocente);